import React, { useState } from 'react';
import { AnimatePresence, Reorder } from 'framer-motion';
import { BookmarkIcon } from 'lucide-react';
import { Modal } from '../../../ui/Modal';
import { PillButton } from '../../../ui/PillButton';
import { ConfirmDialog } from '../../../ui/ConfirmDialog';
import { ProfileCard } from './ProfileCard';
import type { SupportProfile } from '../../../../types/supportProfiles';
type ManageProfilesModalProps = {
  profiles: SupportProfile[];
  onCancel: () => void;
  onSave: (profiles: SupportProfile[]) => void;
};
export function ManageProfilesModal({
  profiles,
  onCancel,
  onSave
}: ManageProfilesModalProps) {
  const [draft, setDraft] = useState(profiles);
  const [confirm, setConfirm] = useState(false);
  const dirty = JSON.stringify(draft) !== JSON.stringify(profiles);
  const byId = new Map(draft.map(p => [p.id, p]));
  const update = (id: string, patch: Partial<SupportProfile>) => setDraft(d => d.map(p => p.id === id ? {
    ...p,
    ...patch
  } : p));
  const requestClose = () => dirty ? setConfirm(true) : onCancel();
  return <Modal title="Manage Saved Profiles" description="Rename profiles, change their icons, and drag to reorder them." onRequestClose={requestClose} suspendEscape={confirm} width={400} footer={<>
          <PillButton className="h-[28px] flex-none px-4" onClick={requestClose} data-id="element-534" data-mp="ts1fk326hzup">
            Cancel
          </PillButton>
          <PillButton variant="primary" className="ml-auto h-[28px] flex-none px-6" onClick={() => onSave(draft)} data-id="element-535" data-mp="xstqr1um2etm">
            Save
          </PillButton>
        </>} overlay={<AnimatePresence data-id="element-536" data-mp="17k7nj1v6h0j2">
          {confirm && <ConfirmDialog title="Save changes to your profiles?" message="Are you sure you don’t want to save the changes to your profiles? Unsaved changes will be lost." confirmLabel="Save Changes" discardLabel="Don’t Save" onCancel={() => setConfirm(false)} onDiscard={onCancel} onConfirm={() => onSave(draft)} data-id="element-537" data-mp="17liq4ycw028l" />}
        </AnimatePresence>} data-id="element-533" data-mp="ewv95ez67z0u">
      
      {draft.length === 0 ? <div className="flex flex-col items-center px-6 py-8 text-center" data-id="element-538" data-mp="3dls5ojdeko22">
          <BookmarkIcon className="h-[20px] w-[20px] text-pf-faint" strokeWidth={1.8} data-id="element-539" data-mp="3rc58667izak0" />
          <p className="mt-2 text-[12.5px] font-semibold text-pf-ink" data-id="element-540" data-mp="3mkn7zkdbte03">No saved profiles yet</p>
          <p className="mt-1 text-[11.5px] leading-snug text-pf-muted" data-id="element-541" data-mp="545pj96vlsmi">Use “Save Current as Profile…” in the Profile menu to save your support settings.</p>
        </div> : <Reorder.Group axis="y" values={draft.map(p => p.id)} onReorder={(ids: string[]) => setDraft(ids.map(id => byId.get(id)).filter((p): p is SupportProfile => !!p))} className="flex flex-col gap-[8px]" data-id="element-542" data-mp="7ygv8n3i30v">
        
          {draft.map(p => <ProfileCard key={p.id} profile={p} onRename={name => update(p.id, {
        name
      })} onIconChange={icon => update(p.id, {
        icon
      })} data-id="element-543" data-mp="2fx07f7qyfm31" />)}
        </Reorder.Group>}
    </Modal>;
}